var map = {
	"./blue/about.png": 7925,
	"./blue/banner/loto-590.png": 4461,
	"./blue/banner/loto.png": 302,
	"./blue/banner/sports.png": 3735,
	"./blue/bg.png": 8276,
	"./blue/calendar.png": 1109,
	"./blue/chevron.png": 5473,
	"./blue/history.png": 7251,
	"./blue/home.png": 6349,
	"./blue/loto.png": 6453,
	"./blue/lotto/lucky-3-en.png": 7151,
	"./blue/lotto/lucky-3-fr.png": 4217,
	"./blue/lotto/lucky-4-en.png": 6728,
	"./blue/lotto/lucky-4-fr.png": 405,
	"./blue/lotto/lucky-5-en.png": 4027,
	"./blue/lotto/lucky-5-fr.png": 9604,
	"./blue/number.png": 8871,
	"./blue/print.png": 6038,
	"./blue/report-final.png": 6160,
	"./blue/report.png": 4869,
	"./blue/result.png": 699,
	"./blue/scan.png": 9530,
	"./blue/sports.png": 3966,
	"./darkblue/about.png": 4423,
	"./darkblue/banner/banner-logo.png": 4039,
	"./darkblue/banner/instant-lotto.png": 1689,
	"./darkblue/banner/lotto-daily.png": 2341,
	"./darkblue/banner/sports.png": 8860,
	"./darkblue/bg.png": 3426,
	"./darkblue/calendar.png": 613,
	"./darkblue/chevron.png": 4086,
	"./darkblue/history.png": 6874,
	"./darkblue/home.png": 9941,
	"./darkblue/loto.png": 9465,
	"./darkblue/lotto/lucky-3-en.png": 6672,
	"./darkblue/lotto/lucky-3-fr.png": 9022,
	"./darkblue/lotto/lucky-4-en.png": 8365,
	"./darkblue/lotto/lucky-4-fr.png": 6534,
	"./darkblue/lotto/lucky-5-en.png": 1134,
	"./darkblue/lotto/lucky-5-fr.png": 1225,
	"./darkblue/number.png": 1981,
	"./darkblue/print.png": 9721,
	"./darkblue/report-final.png": 3876,
	"./darkblue/report.png": 8535,
	"./darkblue/result.png": 9844,
	"./darkblue/scan.png": 8120,
	"./darkblue/sports.png": 9912,
	"./orange/about.png": 5864,
	"./orange/banner/number.png": 6065,
	"./orange/banner/sports.png": 4542,
	"./orange/bg.png": 5045,
	"./orange/calendar.png": 371,
	"./orange/chevron.png": 4777,
	"./orange/history.png": 9678,
	"./orange/home.png": 522,
	"./orange/logo.png": 3232,
	"./orange/loto.png": 26,
	"./orange/lotto/lucky-3-en.png": 8880,
	"./orange/lotto/lucky-3-fr.png": 365,
	"./orange/lotto/lucky-4-en.png": 7619,
	"./orange/lotto/lucky-4-fr.png": 4277,
	"./orange/lotto/lucky-5-en.png": 7219,
	"./orange/lotto/lucky-5-fr.png": 9586,
	"./orange/number.png": 6449,
	"./orange/print.png": 9479,
	"./orange/report-final.png": 9088,
	"./orange/report.png": 5026,
	"./orange/result.png": 3799,
	"./orange/scan.png": 5943,
	"./orange/sports.png": 8853
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8259;